export default function AboutHero() {
  return (
    <>
      <section id="about_hero" className="hero-section-all">
        <div className="container">
          <div className="about-hero-wrapper">
            <h1>Here Comes the Sun</h1>
            <p>
              Cue the Beatles tune, softly in your head only - licensing ain't
              cheap
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
